import React, { useEffect, useState } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

const EventTips = ({ id }) => {
  const [tipsList, setTipsList] = useState([]);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `EventTips/GetEventTipsDetailsById?displayedInId=${id}`
      );
      if (response && response.length > 0) {
        const sortedTips = response.sort((a, b) => a.sortOrder - b.sortOrder);
        setTipsList(sortedTips);
      } else {
        setTipsList([]);
        console.log("No event tips found");
      }
    } catch (error) {
      console.error("Error fetching event tips:", error);
      setTipsList([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    if (tipsList?.length) {
      $(".eventtips .owl-carousel").owlCarousel({
        loop: true,
        margin: 30,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        navText: [
          "<span class='lnr ti-angle-left'></span>",
          "<span class='lnr ti-angle-right'></span>",
        ],
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
          },
        },
      });
    }
  }, [JSON.stringify(tipsList)]);

  if (!tipsList || tipsList.length === 0) {
    return null;
  }

  return (
    <section className="eventtips section-padding">
      <div className="container">
        <div className="row mb-30">
          <div className="col-md-3">
            <div className="sub-title border-bot-light">Our Services</div>
          </div>
          <div className="col-md-9">
            <div className="section-title">Event Tips</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="owl-carousel owl-theme">
              {tipsList.map((tip, index) => (
                <div
                  className="item"
                  key={tip.eventTipsID}
                  style={{ height: "410px" }}
                >
                  <span className="number">{index + 1}</span>
                  <div className="icon">
                    {/* Optionally use dynamic icons or placeholders */}
                    <i className="flaticon-icon-placeholder" />
                  </div>
                  <h5>
                    <a href="#">{tip.title}</a>
                  </h5>
                  <p>{tip.description}</p>
                </div>
              ))}
            </div>
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <a
                href="/ContactUs"
                className="butn-dark2"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  width: "200px",
                  textAlign: "center",
                }}
              >
                <span>Contact US</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventTips;
